'use client';

import dynamic from 'next/dynamic';
import { useStore } from '@/providers/StoreProvider';

const EmailStep = dynamic(() => import('./EmailStep').then(mod => mod.EmailStep), {
  loading: () => null,
});
const LoginOTPStep = dynamic(() => import('./LoginOTPStep').then(mod => mod.LoginOTPStep), {
  loading: () => null,
});
const SignupOTPStep = dynamic(() => import('./SignupOTPStep').then(mod => mod.SignupOTPStep), {
  loading: () => null,
});
const SignupDetailsStep = dynamic(
  () => import('./SignupDetailsStep').then(mod => mod.SignupDetailsStep),
  { loading: () => null },
);
const VerifyPhoneStep = dynamic(
  () => import('./VerifyPhoneStep').then(mod => mod.VerifyPhoneStep),
  {
    loading: () => null,
  },
);

export function AuthFlowContent() {
  const step = useStore(s => s.authUI.step);
  switch (step) {
    case 'email-input':
      return <EmailStep />;
    case 'login-otp':
      return <LoginOTPStep />;
    case 'signup-otp':
      return <SignupOTPStep />;
    case 'signup-details':
      return <SignupDetailsStep />;
    case 'verify-phone':
      return <VerifyPhoneStep />;
    default:
      return <EmailStep />;
  }
}
